export default __webpack_public_path__ + "static/media/papeis-papelao.4ebdb35a.svg";